import styled from 'styled-components';
import {darkPurple, grape, weliregBlue} from '../../styles/shared/colors';
import PageSection from '../PageSection';

export const Arrow = styled.div`
  width: 15px;
  height: 15px;
  border-top: 2px solid ${(props) => props.multiBrand ? darkPurple :weliregBlue};
  border-right: 2px solid ${(props) => props.multiBrand ? darkPurple :weliregBlue};
  transform: rotate(-45deg);
  margin: 0 auto 4px;
  transition: border 0.3s;
`;

export const Button = styled.button`
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.multiBrand ? darkPurple :weliregBlue};
  font-weight: ${(props) => props.multiBrand ? "600" : "500"};
  border: 0;
  background-color: transparent;
  transition: 0.3s color;

  &:hover {
    color: ${grape};

    ${Arrow} {
      border-color: ${grape};
    }
  }
`;

export const ScrollToTopWrapper = styled(PageSection)`
${(props) => props.multiBrand ? `
    padding: 64px 0px;
  `:
  ``}

`